import React from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import NavigationDrawer from './NavigationDrawer'
import Header from './Header'
import AcceptLegalDocumentsModal from 'components/Legal/AcceptLegalDocumentsModal'


const Layout = ({ children }) => {
  const identity = useSelector(state => state.identity)
  const { signedIn } = identity
  const location = useLocation()
  const isOnboarding = location.pathname === '/onboarding'
  const isEmployerKiosk = location.pathname.startsWith('/super/employer-kiosk')
  const isPendingApproval = location.pathname === '/pending-approval'

  const isPendingEmployerUser = signedIn
    && !!identity.employerUserId
    && !identity.isSuper
    && identity.registrationStatus === 'Pending'

  if (isPendingEmployerUser && !isPendingApproval) {
    return <Navigate to='/pending-approval' replace />
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflowX: 'hidden' }}>
      <AcceptLegalDocumentsModal />
      {signedIn && !isOnboarding && !isEmployerKiosk && !isPendingApproval ? (
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
          <NavigationDrawer />
          <Box
            component="main"
            sx={{
              flex: 1,
              minWidth: 0,
              minHeight: 0,
              overflow: 'auto',
              backgroundColor: 'background.default',
              pt: { xs: 'calc(56px + var(--filter-bar-height, 0px))', md: 'var(--filter-bar-height, 0px)' },
            }}
          >
            {children}
          </Box>
        </Box>
      ) : (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
            backgroundColor: 'background.default',
          }}
        >
          {!signedIn && <Header />}
          {children}
        </Box>
      )}
    </Box>
  )
}

export default Layout
